const dropzone = () => {

	function hideAllErrorElements(dropZone) {
 	   let errorElements = dropZone.querySelectorAll('.dropzone-error-size, .dropzone-error-type');
	    errorElements.forEach(errorElem => {
	        errorElem.style.display = 'none';
	    });
	}

	function validateFiles(files, dropZone) {
		let max_file_size=10;  // 10 MB

	    if (files.length > 0) {

	        hideAllErrorElements(dropZone);

	        let fileType = files[0].type.toLowerCase();
	        let fileSize = files[0].size;

			if (fileSize > max_file_size * 1024 * 1024 || (fileType !== 'application/msword' && fileType !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && fileType !== 'application/vnd.oasis.opendocument.text' && fileType !== 'application/pdf' && fileType !== 'text/rtf' && fileType !== 'text/plain')) {
				dropZone.querySelector('.file-input').value = '';
	        	dropZone.querySelector('.file-name').style.display = "none"
	            dropZone.querySelector('.file-name').textContent = '';

	            if (fileSize > max_file_size * 1024 * 1024) {
	                dropZone.querySelector('.dropzone-error-size').style.display = 'block';
	            } else {
	                dropZone.querySelector('.dropzone-error-type').style.display = 'block';
	            }

	            dropZone.classList.add('is-invalid');
	            dropZone.classList.remove('is-valid');

	            return false;
	        } else {
	        	dropZone.querySelector('.file-name').style.display = "block"

	            dropZone.querySelector('.file-name').textContent = files[0].name;

	            dropZone.classList.add('is-valid');
	            dropZone.classList.remove('is-invalid');

	            dropZone.querySelector('.dropzone-error-type').style.display = 'none';
	            dropZone.querySelector('.dropzone-error-size').style.display = 'none';

	            return true;
	        }
	    }

	    return true;
	}

	let dropZonesContainer = document.getElementById('dropzones-container');
	let dropZoneIndex = 1;

	function attachDropZoneEvents(dropZone) {
	    dropZone.addEventListener('drag', preventDefaults);
	    dropZone.addEventListener('dragstart', preventDefaults);
	    dropZone.addEventListener('dragend', preventDefaults);
	    dropZone.addEventListener('dragover', handleDragOver);
	    dropZone.addEventListener('dragenter', handleDragEnter);
	    dropZone.addEventListener('dragleave', handleDragLeave);
	    dropZone.addEventListener('drop', handleDrop);

	    dropZone.addEventListener('click', function (e) {
	        if (e.target !== dropZone.querySelector('.file-input')) {
	            e.preventDefault();
	            dropZone.querySelector('.file-input').click();
	        }
	    });

	    dropZone.querySelector('.file-input').addEventListener('change', function () {
	        if (this.files.length > 0) {
	        	dropZone.querySelector('.file-name').style.display = "block"
	            dropZone.querySelector('.file-name').textContent = this.files[0].name;
	            dropZone.querySelector('.file-input').files = this.files;
	            console.log(this.files);
	            validateFiles(this.files, dropZone);
	        }
	    });
	}

	function preventDefaults(e) {
	    e.preventDefault();
	    e.stopPropagation();
	}

	function handleDragOver(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    // this.classList.add('hover', 'animate-pulse');
	}

	function handleDragEnter() {
	//    this.classList.add('hover', 'animate-pulse');
	}

	function handleDragLeave() {
	    // this.classList.remove('hover', 'animate-pulse');
	}

	function handleDrop(e) {
	    e.preventDefault();
	    e.stopPropagation();

	    let files = e.dataTransfer.files;
	    if (validateFiles(files, this)) {
	        let fileInput = this.querySelector('.file-input');

	        // Get Livewire component and upload file directly via Livewire API
	        let livewireComponent = Livewire.find(fileInput.closest('[wire\\:id]')?.getAttribute('wire:id'));
	        if (livewireComponent && files[0]) {
	            livewireComponent.upload('files', files[0],
	                (uploadedFilename) => {
	                    // Success callback
	                    console.log('File uploaded to Livewire:', uploadedFilename);
	                },
	                () => {
	                    // Error callback
	                    console.error('Livewire file upload failed');
	                },
	                (event) => {
	                    // Progress callback
	                    console.log('Upload progress:', event.detail.progress);
	                }
	            );
	        }

	        this.querySelector('.file-name').style.display = "block"
	        this.querySelector('.file-name').textContent = files[0].name;
	    }
	}

	function checkLastDropZone() {
	    let dropZones = document.querySelectorAll('.dropzone-photo');
	    let lastDropZone = dropZones[dropZones.length - 1];

	    if (lastDropZone.querySelector('.file-input').files.length > 0) {
	        createDropZone();
	    }
	}

	document.querySelectorAll('.dropzone-photo').forEach(dropZone => {
	    attachDropZoneEvents(dropZone);
	});

}

export default dropzone;
